'use client'

import React from 'react'
import {QueryClientProvider as TanStackQueryClientProvider} from '@tanstack/react-query'
import {getQueryClient} from '../../lib/queryClient'

interface QueryClientProviderProps {
    children: React.ReactNode
}

export function QueryClientProvider({children}: QueryClientProviderProps) {
    const client = getQueryClient()

    return (
        <TanStackQueryClientProvider client={client}>
            {children}
        </TanStackQueryClientProvider>
    )
}

